module.exports = __webpack_public_path__ + "assets/img/5.b3c05a1c.jpg";